{
  "account": {
    "title": "Min konto",
    "list": {
      "title": "Konti",
      "description": "Oversigt over fakturaer fra tilknyttede konti"
    },
    "form": {
      "name": {
        "title": "Navn",
        "description": "Dit kontonavn"
      },
      "password": {
        "title": "Adgangskode",
        "description": "Indstil en ny adgangskode til din konto; lad feltet stå tomt for at beholde den nuværende"
      },
      "emailPreferences": {
        "title": "E-mail-præferencer",
        "description": "Vælg typer af e-mailnotifikationer"
      }
    },
    "billing": "Faktureringsoplysninger",
    "subscriptions": "Abonnementer",
    "manageSubscription": "Administrer abonnement",
    "popup": {
      "cancel": "Er du sikker på, at du vil opsige dit abonnement?<br/>Din hjemmeside fortsætter med at blive oversat indtil udgangen af den nuværende abonnementsperiode. Derefter deaktiveres oversættelse.<br/>Bemærk venligst, at du ikke er berettiget til refusion for den ubrugte periode.",
      "downgrade": "Er du sikker på, at du vil nedgradere? Nedgraderingen træder i kraft øjeblikkeligt.<br/>Bemærk venligst, at du ikke er berettiget til refusion for den resterende del af den nuværende faktureringscyklus.<br/>Den nye plans pris vil gælde fra næste faktureringscyklus.",
      "default": "Er du sikker på, at du vil ændre din plan?",
      "resume": "Er du sikker på, at du vil genoptage dit abonnement?"
    }
  },
  "ai_translation": {
    "header": "AI-oversættelse",
    "plan": {
      "header": "AI-oversættelsespriser",
      "used": "Du har brugt {words_used} / {words_allowed} oversatte ord i dine AI-kredits.",
      "remaining": "Tilgængelige AI-kredits:",
      "words": "ord",
      "add_more_credits": "Tilføj flere AI-kredits",
      "details": {
        "idiomatic_expressions": "Idiomer og fagudtryk",
        "background_translation": "Oversættelser i baggrunden",
        "best_website": "Hjemmeside, der kræver perfekt oversættelseskvalitet",
        "page_context": "Side- og webstedskontekst til oversættelse",
        "perfect_quality": "Perfekt kvalitet til en overkommelig pris",
        "no_recurring": "Ingen løbende betaling, forudbetalt kvote",
        "save_40": "Spar 40 % sammenlignet med $20-planen",
        "save_50": "Spar 50 % sammenlignet med $20-planen"
      },
      "quota": "{estimated_words} ord ~ {estimated_pages} sider"
    },
    "settings": {
      "banner": {
        "title": "Linguise AI-oversættelse",
        "intro": "Linguise præsenterer stolt Linguise AI-oversættelse – en ny premium-funktion, der udnytter AI LLM-modeller (de nyeste Llama-modeller optimeret til oversættelsesopgaver). Udviklet til hjemmesider, der kræver fejlfri præcision, og som tager højde for både side- og hele webstedskonteksten for uovertrufne resultater. Giv dine kunder den højeste oversættelseskvalitet, og sørg for, at deres budskab rammer perfekt på alle sprog.",
        "button": "Opgrader nu"
      },
      "alert": {
        "description": "Denne funktion er ikke inkluderet i din nuværende plan og kræver et separat køb.\nAktivér denne tilføjelse for at låse alle nedenstående muligheder op."
      },
      "languages": {
        "title": "Anvend AI-oversættelse på sprog",
        "description": "Vælg specifikt sprog, hvor du ønsker, at AI-oversættelse skal anvendes"
      },
      "button": {
        "save": "Gem indstillinger"
      },
      "form": {
        "advanced": {
          "title": "Avancerede AI-instruktioner",
          "description": "Avancerede AI-instruktioner"
        },
        "enable_mode": {
          "title": "AKTIVER AI-OVERSÆTTELSE",
          "description": "Vælg, hvordan AI-oversættelse skal aktiveres.\nKun regler anvender nedenstående regler.\nKun live-editor gør det muligt at aktivere oversættelse side for side fra live-editor-visningen.\nRegler og live-editor bruger begge funktioner.",
          "disabled": "Deaktiveret",
          "rules": "Kun regler",
          "live_editor": "Kun live-editor",
          "all": "Regler og live-editor"
        },
        "rule_application": {
          "description": "Anvend AI-oversættelse på statisk indhold, dynamisk indhold eller begge dele",
          "title": "Anvend på indhold",
          "all": "Alt indhold",
          "static": "Statisk indhold",
          "dynamic": "Dynamisk indhold"
        },
        "website_topic": {
          "title": "Hjemmesidens emne",
          "placeholder": "Sushi-restaurant...",
          "description": "Definér dit websteds emne for bedre oversættelseskvalitet (f.eks. jura, sushi-restaurant, cykelreservedler webshop…)\nAngiv venligst emnet på engelsk."
        },
        "apply_to_urls": {
          "title": "Anvend på URL'er",
          "description": "Vælg specifikke URL'er, hvor du ønsker, at AI-oversættelse skal anvendes",
          "all_urls": "Alle URL'er",
          "selected_urls": "Valgte URL'er",
          "label": "URL, den skal anvendes på",
          "placeholder": "URL, den skal anvendes på",
          "wildcard": "Jokertegn",
          "regex": "Regulært udtryk",
          "add": "Tilføj ny",
          "expression": "Udtrykstype"
        },
        "apply_languages": {
          "title": "Anvend på sprog",
          "description": "Vælg specifikke sprog, hvor du ønsker, at AI-oversættelse skal anvendes",
          "all_languages": "Alle sprog",
          "selected_languages": "Valgte sprog",
          "placeholder": "Vælg sprog...",
          "feedback": "Du skal vælge et sprog"
        },
        "formality": {
          "title": "Formalitet",
          "description": "Angiv graden af formalitet i oversættelser – evt. vigtigt for målgrupper og kontekst.\n\"Neutral\" forsøger at bevare originalens formalitetsgrad.\n\"Formel\" er til professionelt, forretningsmæssigt eller juridisk indhold (dvs. brug af formelle pronomener som \"usted\" på spansk).\n\"Uformel\" er til uformelt, konversationelt indhold (dvs. brug af \"tú\" på spansk).",
          "neutral": "Neutral",
          "formal": "Formel",
          "informal": "Uformel"
        },
        "sentence_structure": {
          "classic": "Klassisk",
          "short": "Korte og slagkraftige sætninger",
          "detailed": "Detaljerede og forklarende sætninger",
          "title": "Sætningsstruktur",
          "description": "Definér præference for skrivestil."
        },
        "content_purpose": {
          "marketing": "Marketing/promovering (overbevisende, engagerende tone)",
          "technical": "Teknisk/instruerende (klar, præcis, handlingsorienteret)",
          "support": "Kundesupport (empatisk, hjælpsom, beroligende)",
          "legal": "Juridisk/overholdelse (præcis, formel, entydig)",
          "educational": "Undervisende (klar, struktureret, tilgængelig)",
          "other": "Andet (på engelsk)",
          "title": "Indholdets formål",
          "description": "Definér det funktionelle formål med det indhold, der oversættes.",
          "other_placeholder": "Beskriv formålet..."
        },
        "target_audience": {
          "title": "Målgruppe",
          "description": "Specifikation af den tiltænkte målgruppe for det oversatte indhold (på engelsk).",
          "placeholder": "f.eks. spansktalende forældre, EU's databeskyttelsesansvarlige"
        },
        "override_default_translations": {
          "title": "Tilsidesæt standardoversættelse",
          "description": "Hvis dette indstilles til JA, vil indholdet blive oversat med AI (Linguise AI), selvom det allerede er oversat med Cloud AI-oversættelse (standardoversættelsesmodellen)."
        },
        "force_replace_before": {
          "title": "Gennemtving AI-genoversættelse",
          "description": "Oversæt igen med AI alt indhold, hvis AI-oversættelse blev oprettet før den valgte dato — for eksempel indhold oversat med en ældre model. Genoversættelsen sker ved næste besøg på de relevante sider i henhold til reglerne og bruger dine AI-kreditter.",
          "before_date": "Før en dato"
        },
        "model": {
          "current": "Nuværende",
          "title": "Model",
          "description": "Vælg den LLM-oversættelsesmodel, du vil bruge",
          "load_error": "Kan ikke indlæse tilgængelige modeller. Prøv venligst igen senere.",
          "thinking_warning": "Denne model anvender et højt niveau af ræsonnement (\"tænkning\") og vil forbruge væsentligt flere tokens pr. oversættelse."
        },
        "override_manual_and_selected": {
          "no_default": "Nej (standard)",
          "title": "Overskriv manuelle og valgte oversættelser",
          "description": "Som standard vises en oversættelse, du har redigeret manuelt, altid på dit website, også efter at der er genereret en AI-forbedret oversættelse. Sæt til JA for i stedet at vise den AI-forbedrede oversættelse. Dine manuelle oversættelser bevares, og du kan altid skifte tilbage. Dette gælder også, når du oversætter siderne igen for at få nye oversættelser; den nyeste oversættelse bruges automatisk."
        }
      },
      "message": {
        "save_success": "Af det nuværende oversatte indhold vil omkring {{ai_affected_urls}} sider blive forbedret med AI-oversættelse.",
        "save_success_only": "Indstillinger blev gemt."
      }
    },
    "pricing": {
      "plan": {
        "title": "Bestil AI-oversættelseskvote",
        "buy_button": "KØB AI-OVERSÆTTELSESPAKKE"
      },
      "modal": {
        "title": "Bekræft planændring",
        "description": "Er du sikker på, at du vil ændre din AI-oversættelsesplan?",
        "button_cancel": "Annuller",
        "button_confirm": "Bekræft",
        "loading": "Vent venligst...",
        "amount": "Beløb",
        "credit": "Kredit",
        "total_due": "Samlet beløb"
      },
      "comparison": {
        "title": "Google Cloud AI-oversættelse\nvs Linguise AI-oversættelse",
        "list": {
          "0": {
            "google": "Hurtige og pålidelige oversættelser",
            "linguise": "Håndterer idiomer og tekniske udtryk"
          },
          "1": {
            "google": "Øjeblikkelig oversættelse af alle websidens sider",
            "linguise": "Generering af oversættelser i baggrunden"
          },
          "2": {
            "google": "Bedste kvalitet, lav pris",
            "linguise": "Perfekt kvalitet, overkommelig pris"
          },
          "3": {
            "google": "Bedst til store websteder eller lavt budget",
            "linguise": "Bedst til websteder, der kræver perfekt oversættelseskvalitet"
          },
          "4": {
            "google": "Sidekontekst til oversættelse",
            "linguise": "Side- og websteds kontekst til oversættelse"
          }
        }
      },
      "botom_banner": {
        "title": "Oplev uovertruffen oversættelsesnøjagtighed med",
        "sub_title": "Den nye Linguise AI-oversættelse",
        "description": "Linguise forbedrer sine automatiske oversættelsestjenester med introduktionen af Linguise AI-oversættelse, en kraftfuld ny mulighed, der udnytter banebrydende AI-oversættelse LLM (de nyeste Llama-modeller optimeret til oversættelser). Denne tilføjelse giver webudviklere og webbureauer et endnu højere niveau af oversættelseskvalitet, ideelt til projekter, hvor perfektion er afgørende. Linguise AI-oversættelse supplerer vores eksisterende, højkvalitative Google Cloud AI-oversættelse og giver dig større fleksibilitet og præcision."
      }
    },
    "success": {
      "tab_title": "Tak for købet af AI-oversættelsesplanen!",
      "title": "Tak for købet af AI-oversættelsesplanen!",
      "subtitle": "Din AI-oversættelsesplan er blevet købt!",
      "message": "Du kan administrere din AI-oversættelsesplan på siden med AI-oversættelsesindstillinger.",
      "home": "Administrer AI-oversættelse"
    }
  },
  "billing": {
    "form": {
      "name": {
        "title": "Navn",
        "description": "Faktureringskontonavn"
      },
      "phone": {
        "title": "Telefon",
        "description": "Faktureringskontotelefon"
      },
      "email": {
        "title": "E-mail",
        "description": "Faktureringskontoe-mail"
      },
      "address": {
        "title": "Adresse",
        "description": "Faktureringskontoadresse",
        "city": "By",
        "country": "Land",
        "address1": "Adresse 1",
        "address2": "Adresse 2",
        "postal": "Postnummer",
        "state": "Stat"
      },
      "tax": {
        "title": "CVR-nummer"
      }
    }
  },
  "checkouts": {
    "header": "Kasse",
    "payment_method": "Vælg betalingsmetode",
    "stripe_card": "Kreditkort (Stripe)",
    "paypal": "PayPal",
    "address": {
      "new": "Indtast ny faktureringsadresse",
      "existing": "Brug eksisterende adresse"
    },
    "pay_stripe": "Bekræft og betal",
    "terms": "Ved at bekræfte din abonnement giver du Linguise lov til at opkræve dig for fremtidige betalinger i overensstemmelse med vores vilkår. Du kan opsige dit abonnement når som helst.",
    "coupon": {
      "title": "Har du en kupon?",
      "placeholder": "Indsæt din kuponkode her",
      "apply": "Anvend",
      "percent": "{{0}}% rabat"
    },
    "add_new": "Tilføj ny",
    "use_existing": "Brug eksisterende betalingsmetode",
    "recurring": {
      "month_single": "Faktureres månedligt",
      "month_many": "Faktureres hver {{count}} måned",
      "year_single": "Faktureres årligt",
      "year_many": "Faktureres hver {{count}} år",
      "day_single": "Faktureres dagligt",
      "day_many": "Faktureres hver {{count}} dag",
      "week_single": "Faktureres ugentligt",
      "week_many": "Faktureres hver {{count}} uge"
    },
    "add_new_no_stripe": "Tilføj nyt kort",
    "summary": {
      "title": "Oversigt",
      "subtotal": "Subtotal",
      "total": "Total"
    }
  },
  "dashboard": {
    "main": {
      "title": "Oversigt"
    },
    "statistics": {
      "main_title": "Statistik for de seneste 30 dage",
      "characters": "Oversatte tegn",
      "words": "Oversatte ord",
      "bandwidth": "Input båndbredde",
      "request": "Anmodninger",
      "page_views": "Sidevisninger pr. sprog (seneste 30 dage)",
      "multilingual_views": "Flersprogede sidevisninger (seneste 30 dage)",
      "most_page_viewed": "20 mest viste sider (seneste 30 dage)",
      "no_data_yet": "Ingen data tilgængelige endnu",
      "th_language": "Sprog",
      "th_page_views": "Sidevisninger",
      "real_visitors": "Rigtige besøgende",
      "crawler": "Webcrawler"
    },
    "planHints": {
      "subscribeButton": "Abonner",
      "upgradeButton": "Opgrader",
      "usedWords": "Du bruger i øjeblikket {words_used} ord",
      "noPlan": "Ingen plan er aktiveret for dette domæne. Abonner på en plan og begynd at oversætte dit websted",
      "noPlanShopify": "Ingen plan er aktiveret for dette domæne. Abonner på en plan i dit Shopify-dashboard og begynd at oversætte dit websted",
      "trialUsage": "Du bruger i øjeblikket {words_used} ord af de {words_allowed} ord, der er inkluderet i prøveplanen.",
      "trialEnds": "Den 1. måneds prøveperiode er aktiv indtil {trial_ends}.",
      "subscribeMessage": "Abonner, før den slutter, for at holde dit websted oversat",
      "subscribeMessageShopify": "Abonner fra dit Shopify-dashboard, før den slutter, for at holde dit websted oversat",
      "trialReachedLimit": "Du har nået det maksimale antal oversatte ord for prøveperioden.\nAbonner på en af vores planer for at fortsætte med at oversætte dit websted.",
      "paidUsage": "Du har brugt {words_used} / {words_allowed} oversatte ord i din plan.",
      "paidReachedLimit": "Du har nået det maksimale antal oversatte ord for den nuværende plan.\nOpgrader din plan for at fortsætte med at oversætte dit webstedsindhold.",
      "trialOfferedUsage": "Du bruger i øjeblikket {words_used} ord af de {words_allowed} ord, der er inkluderet i prøveplanen.(inklusive de {free_words} tilbudte ord)",
      "paidOfferedUsage": "Du har brugt {words_used} / {words_allowed} oversatte ord i din plan.(inklusive de {free_words} tilbudte ord)",
      "noPlanExtra": "Bemærk, at inaktive domæner og deres data slettes automatisk løbende.",
      "planRecommended": "Baseret på dit nuværende oversættelsesvolumen anbefales planen:",
      "planMaximumWords": "{{words}} ord",
      "notHaveTranslatedWords": "Du har ikke lavet nogen oversættelse endnu"
    },
    "translationSetup": {
      "kicker": "OPSÆTNING AF SUBDOMÆNE",
      "title": "Kontrollér oversættelsesopsætning",
      "description": "Gennemgå DNS, oversatte værter, adgang til det oprindelige website og kontogrænser.",
      "starting": "Kontrollerer...",
      "button": "Kontrollér opsætning",
      "viewLatest": "Vis seneste resultat",
      "viewCurrent": "Vis aktuel kontrol",
      "runAgain": "Kør kontrollen igen",
      "viewDetails": "Vis detaljer",
      "hideDetails": "Skjul detaljer",
      "error": "Opsætningen kunne ikke kontrolleres",
      "allPassed": "Alle kontroller bestået",
      "setupNeedsAttention": "Opsætningen kræver opmærksomhed",
      "setupNeedsAttentionDescription": "En eller flere kontroller mislykkedes. Gennemgå punkterne nedenfor, eller kontakt Linguise-support.",
      "lastChecked": "Senest kontrolleret {{time}}",
      "domainOwnership": "Domæneejerskab",
      "domainOwnershipDescription": "Verifikationspost fundet",
      "domainOwnershipFailure": "DNS-posten til bekræftelse af ejerskab kunne ikke verificeres.",
      "translatedHosts": "Oversatte værter",
      "translatedHostsDescription": "{{count}} sprogværter kontrolleret",
      "translatedHostsFailure": "En eller flere CNAME-poster for sprog er forkerte.",
      "subdomainPage": "Subdomæneside",
      "subdomainPageDescription": "{{count}} oversatte sider accepterer HTTPS",
      "subdomainPageFailure": "TLS-forbindelsen mislykkedes ved åbning af en eller flere oversatte sider.",
      "originalSite": "Oprindeligt website",
      "originalSiteDescription": "Kontrol af DNS, TLS og svar fra det oprindelige website",
      "originalSiteFailure": "Kontrollen af det oprindelige websites DNS, TLS eller svar mislykkedes.",
      "documentationAdvice": {
        "dns": "Gennemgå DNS-opsætning",
        "tls": "Gennemgå HTTPS-opsætning",
        "origin": "Gennemgå opsætning af det oprindelige website",
        "diagnostic": "Gennemgå fejlfindingstrinnene"
      },
      "evidence": {
        "originDns": "Oprindelig DNS",
        "originTls": "Oprindelig TLS",
        "originHttp": "Oprindeligt svar",
        "observedTargets": "Observerede mål",
        "recordCount": "Poster fundet",
        "addressCount": "Adresser fundet",
        "statusCode": "HTTP-status",
        "redirect": "Omdirigering",
        "expiresAt": "Certifikatet udløber",
        "raw": "{{key}}",
        "noValue": "Ingen værdi"
      },
      "checkerError": "Nogle kontroller kunne ikke gennemføres.",
      "coreLocation": "Kontrolleret fra {{location}}",
      "status": {
        "queued": "I kø",
        "running": "Kører",
        "completed": "Fuldført",
        "failed": "Mislykkedes",
        "passed": "Bestået",
        "warning": "Advarsel",
        "unknown": "Ukendt",
        "skipped": "Sprunget over",
        "not_applicable": "Ikke relevant"
      }
    },
    "throttling": {
      "title": "Oversættelsesbegrænsning",
      "description": "Midlertidige forbrugsgrænser",
      "unavailable": "Midlertidige oversættelsesgrænser er ikke tilgængelige",
      "window": "{{used}} / {{max}} ord",
      "resetsIn": "Nulstilles om {{time}}",
      "throttled": "Oversættelsen er midlertidigt sat på pause",
      "throttledDescription": "En midlertidig forbrugsgrænse er nået. Oversættelsen genoptages, når perioden nulstilles."
    }
  },
  "domain": {
    "wizard": {
      "stepLabel": "TRIN {{step}} AF {{total}}",
      "doneLabel": "FÆRDIG, DU KAN NU BEGYNDE AT OVERSÆTTE!",
      "finish": {
        "title": "",
        "description": "Dette er API-nøglen til brug på dit websted"
      },
      "instructions": "Installationsvejledning",
      "domainSetting": "Domæneindstilling",
      "step": {
        "titleWordpress": "WordPress",
        "titleJoomla": "Joomla",
        "titlePHP": "PHP-script",
        "wizardWordpressStep1": "1. Installér ",
        "wizardWordpressStep2": "\n 2. I plugin-indstillingerne kopierer og indsætter du din API-nøgle\n",
        "wizardWordpressStep3": "3. Du er klar til at oversætte\n\n",
        "wizardWordpressStep4": "For en mere detaljeret vejledning, se venligst vores dokumentation: ",
        "wizardJoomlaStep1": "1. Joomla-pakke-link: ",
        "wizardJoomlaStep2": "\n2. I udvidelseskonfigurationen skal du kopiere og udfylde din API-nøgle",
        "wizardJoomlaStep3": "3. I modulkonfigurationen skal du angive de sprog, du ønsker at vise, og indsætte dit modul, hvor du har brug for det.",
        "wizardJoomlaStep4": "\n4. Du er klar til at oversætte\n\n",
        "wizardPhpStep1": "1. Download vores php-script og her ",
        "wizardPhpStep2": "\n2. Følg installationsvejledningen på vores dokumentationsside her ",
        "wizardPhpStep3": "\n3. Tilføj modulet til dine sider.",
        "wizardPhpStep4": "\nKopier følgende kode og tilføj den i head-afsnittet af din html-side; den vil automatisk vise skifter-modulet\n",
        "dispatchStep1": "Vi har sendt de påkrævede data til Linguise-pluginnet; du kan nu lukke det følgende vindue.",
        "dispatchStep2": "Hvis tokenet mangler, når du lukker dette vindue, skal du kopiere det følgende token:",
        "dispatchStep3": "Du kan også kopiere dette udsnit for automatisk at aktivere vores flag-skifter",
        "wizardOtherStep1": "Følg instruktionerne nedenfor for at installere Linguise på dit domæne.\n",
        "wizardOtherStep2": "Kopier følgende kode og tilføj den i head-afsnittet af din html-side; den vil automatisk vise skifter-modulet.\n"
      },
      "trialAlreadyUsed": "Det ser ud til, at du allerede har brugt din gratis prøveperiode, så du skal have oversættelseskvote\nDu bedes abonnere på en plan eller kontakte os, hvis du ønsker at forlænge din prøveperiode.",
      "usefulLinks": "Nyttige links til at komme i gang",
      "linkDocumentation": "Dokumentation",
      "linkExtensionDl": "Download af udvidelse",
      "linkSubscribe": "Abonnér på en plan nu",
      "linkDashboard": "Gå til dashboardet",
      "exclusion": {
        "title": "Virksomheds- og produktnavne",
        "description": ""
      },
      "finishButton": "Afslut opsætningen",
      "subdomains": "Underdomæner",
      "subdomain_setup": "Opsæt domæne",
      "subdomain_auto_setup": "Tilslut din DNS automatisk",
      "subdomain_manual_setup": "Tilføj DNS-poster selv",
      "subdomain_skip": "Gør det senere",
      "auto_subdomains_info": "Din site-builder CMS kræver en DNS-konfiguration for at angive sprog pr. underdomæne (f.eks. da.domain.com).",
      "auto_subdomains_info_2": "Du kan gøre det automatisk ved hjælp af Entri. Klik blot på knappen \"Tilslut din DNS automatisk\" for at begynde at oprette forbindelse til din DNS-manager og tilføje dem med Entri.",
      "auto_subdomains_info_manual": "Eller du kan konfigurere dit domæne manuelt ved at klikke på knappen \"Tilføj DNS-poster selv\".",
      "breadcrumbs": {
        "step1": "Trin 1: Domæne, CMS og sprog",
        "step2": "Trin 2: Sprog-DNS",
        "step3": "Trin {{step}}: Installationsvejledning"
      }
    },
    "form": {
      "urls": {
        "dash": "Bindestreg -",
        "underscore": "Understregning _",
        "title": "Oversæt URL'er",
        "description": "Ønsker du at oversætte på alle sider",
        "char_description": "Tegn, der skal bruges til at erstatte uautoriserede tegn i URL'er",
        "advertisement_title": "⚠ Du har valgt mange sprog.\n",
        "advertisement": "Vi anbefaler normalt at begynde med få sprog, når du oversætter hjemmesider. Du vil få en idé om, hvor mange ord din hjemmeside har. Det er også bedre for SEO, da Google-bots hurtigere vil gennemgå alle dine sider, hvis du først har få sider. Efter en uge kan du tilføje flere sprog osv."
      },
      "url": {
        "title": "Url",
        "description": "Indtast din primære domæne-URL, der starter med http:// eller https://",
        "placeholder": "Domæne-URL",
        "advertisement_http": {
          "title": "Du bruger ikke https-protokollen",
          "description": "Kontroller venligst, at dit domæne faktisk ikke bruger https-protokollen, hvilket i dag anbefales."
        },
        "advertisement_www": {
          "title": "Dit underdomæne er ikke www",
          "description": "Oftest er standard-underdomænet www (f.eks. https://www.mitdomæne.dk). Dette er måske ikke tilfældet for dig, men dobbelttjek venligst, at det domæne, du vil tilføje, er det korrekte."
        },
        "invalid_url": {
          "line1": "Vi kunne ikke finde dit domæne. Kontroller venligst, at dit domæne er offentligt tilgængeligt via internettet, og at det ikke viderestilles til et andet sted.",
          "line2": "Hvis du er sikker på, at dit domæne er tilgængeligt, kan du springe domæneverifikation over og trykke på knappen \"Næste trin\" igen.",
          "contact": "Under alle omstændigheder kan du kontakte os på",
          "force": "Spring domæneverifikation over"
        },
        "invalid_subdomain_url": "Denne url er ikke tilladt. Underdomæner skal være i formatet: https://www.domain.tld eller https://domain.tld uden undermappe"
      },
      "account": {
        "title": "Konto",
        "description": "Vælg en konto, der skal tildeles dette domæne",
        "placeholder": "Vælg konto...",
        "feedback": "Du skal vælge en konto"
      },
      "platform": {
        "title": "Platform",
        "description": "Vælg venligst din hjemmesideplatform efter CMS-navn.",
        "learn": "Lær, hvordan du vælger den",
        "placeholder": "Søg efter platform efter CMS-navn...",
        "info": {
          "title": "⚠ Denne platform er for nylig blevet tilføjet.\n",
          "desc": "Denne hjemmeside-builder-platform understøttes af Linguise, selvom den først for nylig er blevet tilføjet. Hvis du oplever problemer, bedes du kontakte os via den direkte support-e-mail:"
        },
        "description_read_only": "Den platform, din hjemmeside bruger",
        "feedback": "Du skal vælge en platform"
      },
      "language": {
        "title": "Sprog",
        "description": "Vælg dit hjemmesides standardsprog",
        "placeholder": "Vælg sprog...",
        "feedback": "Du skal vælge et sprog",
        "description_read_only": "Dit hjemmesides standardsprog"
      },
      "token": {
        "title": "API-nøgle",
        "description": "Dette er API-nøglen, der skal kopieres til din hjemmeside",
        "copy": "Kopier til udklipsholder",
        "reset": "Nulstil API-nøgle",
        "reset_confirm": "Bekræft venligst nulstilling af API-nøgle"
      },
      "languages": {
        "title": "Oversættelsessprog",
        "description": "Vælg de sprog, som din hjemmeside skal kunne oversættes til",
        "placeholder": "Vælg sprog...",
        "feedback": "Du skal vælge et sprog"
      },
      "defaultRules": {
        "title": "Standardregler",
        "description": "Vi har defineret et sæt obligatoriske regler for at forbedre oversættelsen og undgå uønsket indhold, f.eks. WordPress-dashboardet.\nDu kan senere fjerne eller redigere disse regler, hvis du ønsker det."
      },
      "disallow_deletion": "Du kan ikke slette domæne med aktivt abonnement",
      "delete_confirm": "Bekræft venligst sletning af domænet",
      "delete": "Slet domæne",
      "dynamic": {
        "title": "Oversæt dynamisk indhold",
        "description": "Dynamisk indhold genereret af JavaScript og AJAX-forespørgsler vil blive oversat (denne mulighed vil øge din oversættelsesforbrug)"
      },
      "partial_translations": {
        "title": "Tillad delvis oversættelse",
        "description": "Hvis din konto har nået sin oversættelseskvote, men siden stadig kræver oversættelse, kan Linguise fortsætte med at vise siden med det indhold, der allerede er oversat.\nDog vil visse dele af siden forblive uoversatte, indtil du opgraderer din kvote.\n\nMens en lille mængde uoversat indhold normalt ikke skader SEO, kan for meget uoversat indhold påvirke brugeroplevelsen negativt.\nFor at håndtere dette kan du angive en tærskel for den procentdel af uoversat indhold, der er tilladt på en side. Hvis det uoversatte indhold overstiger denne tærskel, bliver brugerne automatisk viderestillet til den oprindelige sprogversion af siden.",
        "never": "Aldrig"
      },
      "translate_error_pages": {
        "title": "Oversæt fejlsider",
        "description": "Linguise kan oversætte alle fejlsider, men hvis din fejlside indeholder dynamisk indhold som IP-adresse eller forespørgsels-ID, bør du undgå at oversætte disse sider.",
        "not_found_page": {
          "title": "Oversæt 404-side"
        },
        "error_page": {
          "title": "Oversæt andre fejlsider"
        }
      },
      "plugin_mode": {
        "modal": {
          "title": "Eksisterende domæne fundet",
          "description": "Der er fundet et eksisterende domæne for denne bruger; ønsker du at bruge det?"
        }
      },
      "search_tl": {
        "title": "Søg oversættelser",
        "description": "Aktivér søgeoversættelser for din hjemmesideplatform (eksperimentelt; denne mulighed vil øge din oversættelsesforbrug)"
      },
      "shopify_promo": {
        "info": "Gode ​​nyheder! Vi har nu en Shopify native-app, som du kan installere fra Shopify App Store",
        "hyperlink": "Klik her og udfør Linguise-installationen fra appen.",
        "next_btn": "Gå til Shopify-butikken for at installere appen",
        "info_legacy": "Gode ​​nyheder! Vi har nu en Shopify native-app, som du kan installere fra Shopify App Store",
        "description_legacy": "Vælg platformen \"Shopify\" i stedet for \"Shopify Legacy\""
      },
      "wix_promo": {
        "info": "Gode nyheder! Vi har nu en Wix native-app, som du kan installere fra Wix App Market.",
        "hyperlink": "Klik her og udfør Linguise-installationen fra appen.",
        "next_btn": "Gå til Wix App Market for at installere appen",
        "info_legacy": "Gode nyheder! Vi har nu en Wix native-app, som du kan installere fra Wix App Market.",
        "description_legacy": "Vælg platformen \"Wix\" i stedet for \"Wix Legacy\""
      },
      "ai_disallow_deletion": "Du kan ikke slette dette domæne, mens en AI-kvote stadig er tilgængelig.\n\nKontakt venligst vores supportteam, hvis du ønsker at slette dette domæne på",
      "language_removal": {
        "card": {
          "title": "Slet oversættelser af fjernede sprog",
          "description": "Disse sprog er fjernet fra dit website, men deres gemte oversættelser tæller stadig med i din kvote. Slet dem for at få ordene tilbage.",
          "button": "Slet oversættelser"
        },
        "hint": "De brugte ord føres tilbage til din kvote. Du kan gøre dette én gang hver {{days}}. dag pr. website.",
        "modal": {
          "title": "Slet oversættelser?",
          "intro": "Disse oversættelser slettes permanent:",
          "warning": "Dette kan ikke fortrydes. De brugte ord føres tilbage til din kvote, hvilket kan tage et par minutter.",
          "limit": "Du kan gøre dette én gang hver {{days}}. dag pr. website.",
          "confirm": "Slet oversættelser"
        },
        "scheduled": "Oversættelserne slettes, og din kvote opdateres snart.",
        "cooldown": "Oversættelser for dette website blev slettet for nylig. Du kan slette dem igen den {{date}}.",
        "latest_completed": {
          "title": "Seneste fuldførte sletning",
          "description": "Se de slettede sprog og de ord, der er ført tilbage til din kvote.",
          "languages": "Slettede sprog",
          "words_returned": "Ord ført tilbage til din kvote: {{words}}",
          "completed_at": "Fuldført {{date}}"
        },
        "status": {
          "recent_title": "Seneste oversættelsessletning",
          "recent_description": "Følg den seneste sletning, og se, hvornår du kan slette igen.",
          "progress_title": "Sletningsforløb",
          "loading": "Kontrollerer sletningsforløbet...",
          "unavailable": "Sletningsforløbet kunne ikke indlæses. Opdater siden, og prøv igen.",
          "label": "Status",
          "pending": "I kø",
          "processing": "I gang",
          "completed": "Fuldført",
          "failed": "Mislykkedes",
          "unknown": "Status ikke tilgængelig",
          "percent": "{{percent}} % fuldført",
          "current_stage": "Aktuelt trin: {{stage}}",
          "processed": "{{processed}} poster behandlet",
          "processed_total": "{{processed}} af {{total}} poster behandlet",
          "requested_at": "Anmodet {{date}}",
          "started_at": "Startet {{date}}",
          "completed_at": "Fuldført {{date}}",
          "cooldown_period": "Du kan gøre dette én gang hver {{days}}. dag pr. website.",
          "cooldown_blocked": "En ny sletning kan ikke startes endnu.",
          "stage": {
            "queued": "Venter på at starte",
            "processing": "I gang",
            "refund_summary": "Beregner returnerede ord",
            "search_translations": "Sletter søgeoversættelser",
            "url_translations": "Sletter URL-oversættelser",
            "translations": "Sletter oversættelser",
            "completed": "Fuldført",
            "failed": "Mislykkedes",
            "unknown": "I gang"
          }
        },
        "forbidden": "Du har ikke tilladelse til at slette oversættelser."
      }
    },
    "main": {
      "edit": "Rediger domæne",
      "add": "Tilføj domæne",
      "wizard": "Velkommen! Guide til oprettelse af nyt domæne",
      "common": "Domæne"
    },
    "notice": {
      "broken_card": "Vi kunne ikke forny din plan for {{url}} med den nuværende betalingsmetode; opdater venligst dit betalingskort",
      "quota_reached": "Din oversættelseskvote for {{url}} er nået; opgrader for at genoptage oversættelsen af din hjemmeside",
      "ai_no_subscription": "AI-oversættelse for {{url}} kræver et aktivt abonnement eller en aktiv prøveperiode. Den stopper uden et sådant; opgrader for at fortsætte",
      "important": "Vigtigt",
      "quota_reached_button": "Opgrader din plan nu",
      "broken_card_button": "Opdater dit betalingskort",
      "ai_no_subscription_button": "Opgrader din plan nu",
      "quota_warning": "Din oversættelseskvote for {{url}} har nået {{throttling_used_percent}}%, dette vil blive nulstillet om {{ttl}}",
      "locked": "Domænet {{url}} er i øjeblikket låst til migrering. Du kan stadig få adgang til dit websted, men du kan ikke redigere eller tilføje nye oversættelser!"
    },
    "subdomains": {
      "config_ok": "Underdomæner DNS er blevet konfigureret korrekt.",
      "config_invalid": "Underdomæner DNS kræver ekstra konfiguration for at fungere.",
      "config_check": "Underdomæner DNS-konfiguration tjekkes, vent venligst...",
      "entri_timeout": "Entri har meddelt, at din underdomæner DNS-udbredelsesproces er udløbet. Du skal prøve igen eller gøre det manuelt.",
      "entri_process": "Din DNS er blevet tilføjet med Entri, og det tager normalt 10-30 minutter at udbrede (anvende alle dine sprogunderdomæner som da.domain.com). Hvis DNS-valideringen ikke er færdig efter 24 timer, kan du kontakte vores supportteam: support@linguise.com",
      "entri_ok": "DNS-udbredelse er i gang! Venter på udbredelse...",
      "infos": "Du skal tilføje disse DNS-poster til dine DNS-domæneposter for at aktivere oversættelsen. Klik på knappen \"tjek\", når det er færdigt. Det er muligt, at DNS-poster kan tage lidt tid at udbrede sig, så du skal muligvis vende tilbage efter et par minutter eller timer.",
      "check": "Tjek DNS-konfigurationen"
    },
    "subscription": {
      "next_payment_amount": "Kommende opkrævninger",
      "next_payment_date": "Næste betalingsdato",
      "invoice": {
        "header": "Fakturahistorik",
        "date": "Dato",
        "amount_due": "Beløb",
        "status": "Status",
        "actions": "Handlinger",
        "description": "Når transaktioner er tilgængelige, kan du se dem her.",
        "status_text": {
          "draft": "Udkast",
          "failed": "Mislykket",
          "open": "Afventer",
          "paid": "Betalt",
          "retrying": "Forsøger igen",
          "uncollectible": "Udpantelig",
          "void": "Ugyldig"
        },
        "view": "Vis",
        "empty": "Der er ingen nylige fakturaer for dette abonnement",
        "retry_payment": "Prøv igen"
      },
      "next_cancellation": "Opsigelsesdato",
      "cancel": "Opsig abonnement",
      "change_plan": "Skift plan",
      "change": "Skift",
      "suspend": "Suspender betaling",
      "resume": "Genoptag abonnement",
      "back": "Tilbage",
      "save": "Gem",
      "confirm_resume": "Er du sikker på, at du vil genoptage dette abonnement?",
      "confirm_cancel": "Er du sikker på, at du vil opsige dette abonnement?",
      "confirm_header": "Er du sikker?",
      "missing_status": "Dette abonnement mangler",
      "not_found": "Der blev ikke fundet noget abonnement for dette domæne",
      "confirm_manual_retry": "Er du sikker på, at du vil prøve denne betaling igen?",
      "no_payment_method": "Ukendt",
      "remove_billing": "Fjern",
      "shopify_maneged": "Dette abonnement administreres af Shopify. Administrér det venligst fra din Shopify-administrationspanel.",
      "unknown_plan": "Ukendt plan"
    }
  },
  "domain_listing": {
    "add": "Tilføj hjemmeside",
    "select": "Vælg et domæne"
  },
  "editable": {
    "number": "nummer {{id}}"
  },
  "footer": {
    "about": "Om",
    "support": "Support"
  },
  "frontendEditor": {
    "main": "Live-editor",
    "description": "Live Editoren hjælper dig med at redigere oversættelserne direkte på din hjemmeside.",
    "button": "Åbn Live Editor",
    "language_selection": "Valg af oversættelsessprog",
    "video_label": "Lær at bruge live editoren"
  },
  "general": {
    "403": {
      "tab_title": "Ups - 403 Fejl",
      "title": "Adgang nægtet",
      "message": "Det ser ud til, at du ikke har adgang til den ønskede side.",
      "home": "Tilbage til forsiden"
    },
    "404": {
      "tab_title": "Ups - 404 Fejl",
      "title": "Side ikke fundet",
      "message": "Det ser ud til, at du er taget en forkert drejning. Bare rolig... det sker for os alle. Her er et lille tip, der kan hjælpe dig tilbage på rette spor.",
      "home": "Tilbage til forsiden"
    },
    "500": {
      "tab_title": "500 Fejl",
      "title": "Intern serverfejl",
      "message": "Hvorfor ikke prøve at opdatere din side? eller du kan kontakte os",
      "home": "Tilbage til forsiden"
    },
    "fields": {
      "alert": "Nogle felter er ugyldige, ret venligst de ugyldige felter.",
      "invalid": "Dette felt er ugyldigt",
      "phone_re": "Telefonnummer er ugyldigt",
      "phone_invalid": "Telefonnummer er ugyldigt",
      "email": "E-mail-feltet er ugyldigt"
    },
    "table": {
      "no_data": "Der er ingen data her endnu..."
    },
    "saving": "Gemmer ...",
    "save": "Gem",
    "save_and_quit": "Gem & Afslut",
    "invite": "Inviter",
    "cancel": "Annuller",
    "yes": "Ja",
    "no": "Nej",
    "nextStep": "Næste trin",
    "loading": "Vent venligst, mens applikationen indlæses",
    "goback": "Gå tilbage",
    "manage": "Administrer",
    "delete": "Slet",
    "deleting": "Sletter ...",
    "confirm": "Bekræft",
    "unknown": "Ukendt",
    "hide": "Skjule",
    "show": "Vise",
    "on": "På",
    "off": "Slukket",
    "default": "Standard"
  },
  "home": {
    "header": "Hjem",
    "manage": "Administrer abonnement",
    "canceled": "Planlagt til opsigelse",
    "activate_now": "Aktivér nu",
    "activate_plan_now": "Abonnér nu",
    "upgrade_plan_now": "Opgrader plan nu",
    "trial_message_part_1": "Du er i øjeblikket på prøveplanen, ",
    "trial_message_part_2": "du kan aktivere et medlemskab når som helst.",
    "add": "Tilføj domæne",
    "table": {
      "title": "Domæner",
      "description": "Liste over dine domæner, klik på domænet for at administrere oversættelser"
    },
    "domains": {
      "empty": "Du har ingen domæner på denne konto"
    },
    "accountsList": {
      "title": "Konti",
      "add": "Tilføj ny konto",
      "name": "Kontonavn"
    },
    "update_credit_card": "Opdater kreditkortoplysninger",
    "cancelling_subs": "Opsiger ved {{0}}",
    "resume_subscription": "Genoptag abonnement",
    "shopify_managed": "Administreret af Shopify",
    "trial_ends_at": "Slutter kl. {{0}}",
    "free_trial": "Gratis prøveversion",
    "no_subs": "Intet aktivt abonnement"
  },
  "invoices": {
    "title": "Fakturaer",
    "list": {
      "title": "Fakturaliste"
    },
    "table": {
      "customer": "Kunde",
      "domain": "Domæne",
      "amountPaid": "Betalt beløb",
      "status": "Status",
      "date": "Dato",
      "invoice": "Faktura",
      "pay": "Betal faktura",
      "actions": "Handlinger",
      "deleted_domain": "Domæne slettet",
      "plan_name": "Abonnement",
      "action": "Handling"
    },
    "listPending": {
      "title": "Ventende fakturaliste"
    }
  },
  "language_settings": {
    "display": "Sproglistevisning",
    "position": "Position",
    "display_help_text": "Vis flag og/eller sprognavne. Standards placering for sprogvælgeren kan være hvor som helst i indholdet eller i en fast position, der forbliver fast eller flytter ved scrolling",
    "side_by_side": "Side om side",
    "dropdown": "Rullemenu",
    "popup": "Popup",
    "flag": "Flag",
    "lang_name": "Sprognavn",
    "lang_short_name": "Korte navne",
    "positions": {
      "in_place": "På stedet",
      "top_left": "Øverst til venstre",
      "top_left_no_scroll": "Øverst til venstre (ingen scrolling)",
      "top_right": "Øverst til højre",
      "top_right_no_scroll": "Øverst til højre (ingen scrolling)",
      "bottom_left": "Nederst til venstre",
      "bottom_left_no_scroll": "Nederst til venstre (ingen scrolling)",
      "bottom_right": "Nederst til højre",
      "bottom_right_no_scroll": "Nederst til højre (ingen scrolling)"
    },
    "lang_names_display": {
      "title": "Visning af sprognavne",
      "help_text": "I sprogvælgeren vises sprognavnene på engelsk eller på originalsproget, fx French eller Français",
      "english": "Engelsk",
      "native_languages": "Oprindelige sprog"
    },
    "flag_shape": {
      "title": "Flagstil",
      "help_text": "Brug runde svg- eller rektangulære svg-flagikoner",
      "round": "Rund",
      "rectangular": "Rektangulær"
    },
    "english_flag_type": {
      "title": "Type af engelsk flag",
      "help_text": "Brug Storbritanniens eller USAs flag for engelsk",
      "usa": "USA-flag",
      "great_britain": "Storbritanniens flag"
    },
    "german_flag_type": {
      "title": "Type af tysk flag",
      "help_text": "Brug Østrigs eller Tysklands flag for tysk",
      "german": "Tysk flag",
      "austria": "Østrigsk flag"
    },
    "spain_flag_type": {
      "title": "Type af spansk flag",
      "help_text": "Brug Mexicos eller Spaniens flag for spansk",
      "spanish": "Spansk flag",
      "mexico": "Mexicansk flag",
      "peruvian": "Peruviansk flag"
    },
    "portugal_flag_type": {
      "title": "Type af portugisisk flag",
      "help_text": "Brug Portugals eller Brasiliens flag for portugisisk",
      "portugal": "Porturgisisk flag",
      "brazil": "Brasiliansk flag"
    },
    "taiwanese_flag_type": {
      "title": "Type af taiwanesisk flag",
      "help_text": "Brug Taiwans eller Kinas flag for taiwanesisk",
      "taiwanese": "Taiwanesisk flag",
      "chinese": "Kinesisk flag"
    },
    "flag_border_radius": {
      "title": "Flagets hjørneradius (px)",
      "help_text": "Hvis du bruger det rektangulære flag, kan du tilpasse hjørneradius i pixel"
    },
    "flag_width": {
      "title": "Flagsstørrelse (px)",
      "help_text": "Vælg flagsstørrelse i pixels. Det ændrer ikke billedevægten, da det er et .svg-format"
    },
    "lang_color": {
      "color_title": "Sprognavnfarve",
      "color_help_text": "Vælg en standard tekstfarve til dine sprognavne",
      "hover_color_title": "Sprognavnfarve ved hover",
      "hover_color_help_text": "Vælg en tekstfarve til dine sprognavne, når musen holdes over",
      "color_popup_title": "Farve på sprognavn i popup",
      "color_popup_help_text": "Farve på sprognavnet i popup eller rullemenuområder",
      "hover_color_popup_title": "Farve på sprognavn ved hover i popup",
      "hover_color_popup_help_text": "Vælg en tekstfarve til sprognavnet i popup/rullemenuområdet ved musoverførsel"
    },
    "flag_box_shadow": {
      "shadow_title": "Flag skygge",
      "shadow_help_text": "Farve og skyggestørrelse for dit sprogflag",
      "hover_shadow_title": "Flag skygge ved hover",
      "hover_shadow_help_text": "Farve og skyggestørrelse for dit sprogflag ved musoverførsel",
      "shadow_h_offset": "Horisontal forskygning (px)",
      "shadow_v_offset": "Vertikal forskydning (px)",
      "shadow_blur": "Sløring (px)",
      "shadow_spread": "Spredning (px)",
      "shadow_color": "Skyggens farve"
    },
    "order": "Sprogrækkefølge",
    "language_order_help": "Rækkefølgen af sprog, der vises i sprogvælgeren. Du kan trække og slippe sprogene for at ændre rækkefølgen.",
    "order_reset": "Nulstil rækkefølge",
    "language_order_dragdrop": "Du kan trække og slippe sprogene for at ændre rækkefølgen.",
    "popup_lang_name": "Popup-sprognavn",
    "preview": "Sprogforhåndsvisning"
  },
  "link": {
    "form": {
      "original": {
        "title": "Oprindelig kilde",
        "description": "Tilføj din oprindelige link-URL og erstatt den nedenfor pr. sproglig oversættelse",
        "srcset_description": "Du redigerer en billed-URL. Læs venligst dokumentationen, især hvis du anvender srcset eller ikke ved hvad det er",
        "link": "Link",
        "match_link": "Match-tilstand",
        "match_exact": "Eksakt",
        "match_wildcard": "Jokertegn",
        "match_regex": "Regulært udtryk"
      },
      "alternative_languages": {
        "title": "Links der skal erstattes",
        "description": "Erstat medielinks og eksterne links på alle dine sider efter sprog…",
        "link": "Link der skal erstattes"
      },
      "error": {
        "atLeastOne": "Tilføj venligst mindst én oversættelse.",
        "url": "Url'en er ugyldig",
        "extension": "Linket skal have en filtype, men det må ikke være .html eller .php. Linket må ikke indeholde et sprogsti, fx \"/fr\"",
        "regex": "Regulært udtryk er ugyldigt",
        "wildcard": "Wildcard-linket har et ugyldigt protokol"
      }
    },
    "main": {
      "parent": "Links",
      "edit": "Redigér link"
    }
  },
  "links": {
    "title": "Administration af medie- og eksterne links",
    "description": "Vis og redigér dine medielinks eller eksterne links.",
    "add": "Tilføj link",
    "delete": "Slet link",
    "table": {
      "original": "Oprindelig",
      "language": "Sprog",
      "translation": "Oversættelse",
      "action": "Handling",
      "delete_confirm": "Bekræft venligst sletning af link"
    }
  },
  "members": {
    "header": "Medlemmer",
    "invite": "Invitér nyt medlem",
    "modal": {
      "inviteHeader": "Invitér nyt medlem",
      "editHeader": "Redigér medlem",
      "detachHeader": "Frakobl medlem",
      "detachBody": "Er du sikker på, at du vil frakoble medlemmet fra denne konto?",
      "selfDetachBody": "Er du sikker på, at du vil frakoble dig selv fra administrationen af denne konto? Derefter vil du ikke længere kunne tilgå nogen data relateret til denne konto."
    },
    "table": {
      "title": "Medlemsliste",
      "description": "Medlemsroller og domæneadgang",
      "name": "Navn",
      "email": "E-mail",
      "websites": "Websteder",
      "languages": "Sprog",
      "role": "Rolle",
      "status": "Status",
      "resendInvite": "gensend",
      "inviteSent": "invitation er sendt",
      "actions": "Handlinger",
      "edit": "Redigér",
      "detach": "Frakobl",
      "empty": "Du har ingen medlemmer endnu",
      "all_website": "Alle websites og sprog",
      "roles": {
        "admin": "Administrator",
        "manager": "Manager",
        "translator": "Oversætter"
      },
      "statuses": {
        "pending": "Afventer",
        "accepted": "Accepteret",
        "declined": "Afvist"
      }
    },
    "errors": {
      "role": "Du skal vælge en rolle",
      "domains": "Du skal vælge mindst ét websted for den valgte rolle",
      "languages": "Du skal vælge mindst ét sprog for de valgte websteder"
    },
    "inviteSent": "Din invitation er blevet sendt"
  },
  "pagination": {
    "showing": "Viser {{limit}} af {{total}} resultater",
    "showing_only_count": "Viser {{limit}} resultater"
  },
  "payments_method": {
    "header": "Betalingsmetoder",
    "table": {
      "title": "Liste over betalingsmetoder",
      "description": "Tilknyttede betalingsmetoder til din konto",
      "default": "Standard",
      "action_edit_remove": "Redigér eller fjern",
      "action_remove": "Fjern",
      "action_default": "Sæt som standard",
      "action_fallback": "Sæt som fallback",
      "expires": "Udløber",
      "add_new_card": "Tilføj betalingsmetode",
      "action_fallback_remove": "Fjern fra fallback",
      "fallback": "Reservevalg",
      "action_edit": "Redigér",
      "action_delete": "Slet",
      "action_default_remove": "Fjern som standard",
      "domain_count@@one": "Bruges af {{count}} domæner",
      "domain_count@@other": "Brugt af {{count}} domæner"
    },
    "paypal_bind": {
      "button": "Tilslut PayPal-konto",
      "button_load": "Tilslutter...",
      "disconnected": "Ikke tilsluttet",
      "success": "Din PayPal-konto er nu tilsluttet, der vil blive trukket $5 fra din næste faktura!",
      "success_no_promo": "Din PayPal-konto er nu tilsluttet",
      "error": "Der opstod en fejl",
      "success_header": "Succes"
    },
    "card_add": {
      "header": "Tilføj nyt kort",
      "success": "Nyt kort tilsluttet Linguise!",
      "terms": "Ved at give dine kortoplysninger giver du Linguise tilladelse til at opkræve dit kort for fremtidige betalinger i henhold til vores servicevilkår."
    },
    "card_detail": {
      "header": "Kortinfo",
      "delete": {
        "error": "Du kan ikke slette denne betalingsmetode, da den har aktive abonnementer!"
      }
    },
    "subscriptions": {
      "table": {
        "description": "Abonnementer på denne betalingsmetode",
        "header_domain": "Domæne",
        "header_plan": "Abonnement",
        "header_status": "Status",
        "header_actions": "Handlinger",
        "cancelling": "Opsiges den: {{0}}",
        "next_payment": "Næste betaling den: {{0}}",
        "action_renew": "Forny",
        "no_subs_header": "Ingen abonnementer at vise",
        "no_subs_desc": "Når der oprettes et abonnement på dette kort, vises alle oplysninger her",
        "action_manage": "Administrér"
      },
      "status": {
        "active": "Aktiv",
        "canceled": "Annulleret",
        "incomplete": "Ubetalt",
        "incomplete_expired": "Ubetalt (udløbet)",
        "missing": "Fejl",
        "past_due": "Forfalden",
        "trialing": "Prøve",
        "unpaid": "Ubetalt"
      }
    },
    "delete_confirm_body": "Er du sikker på, at du vil slette denne betalingsmetode? Denne handling kan ikke fortrydes!",
    "delete_confirm_header": "Slet betalingsmetode?",
    "card_edit": {
      "header": "Redigér kort",
      "billing_header": "Faktureringsoplysninger",
      "address_error": "Adresse er påkrævet!",
      "card_number": "Kortnummer",
      "card_expiry": "Udløbsdato",
      "expiry_error_month": "Ugyldig måned angivet",
      "expiry_error_year": "Ugyldigt år angivet",
      "expiry_error_expired": "Dit korts udløbsår er i fortiden.",
      "card_header": "Kortinformation",
      "expiry_error_empty": "Dette felt er påkrævet!"
    }
  },
  "plans": {
    "per": "pr.",
    "wordsTranslated": "ord oversat",
    "current": "Nuværende",
    "archived": "Arkiveret",
    "day": "dag",
    "week": "uge",
    "month": "måned",
    "year": "år",
    "activate": "Aktivér",
    "cancel": "Annullér",
    "change": "Skift",
    "upgrade": "Opgrader",
    "downgrade": "Nedgrader",
    "resume": "Genoptag",
    "notEnoughWords": "Ikke nok ord",
    "yearIntervalOnly": "Kan ikke skifte fra årlig plan",
    "subsCanceled": "Der er en anden annullering af abonnement i gang",
    "wordsUnlimited": "Ubegrænsede ord",
    "tabs": {
      "day": "Daglige priser",
      "week": "Ugentlige priser",
      "month": "Månedlige priser",
      "year": "Årlige priser",
      "sub_texts": {
        "day": "Én fast pris hver dag",
        "week": "Én fast pris hver uge",
        "month": "Én fast pris hver måned",
        "year": "Én måned gratis, én regning per år"
      }
    },
    "details": {
      "new_languages": "Tilføj nye sprog når som helst",
      "one_month_trial": "Én måneds gratis prøveperiode for hver ny hjemmeside",
      "multi_content_indexed": "100% af multilinguelt indhold indekseret",
      "translate_new_content": "Oversæt nyt indhold med det samme",
      "free_installation": "Gratis installation og opsætning",
      "compared_monthly_plan": "Én måned gratis sammenlignet med månedlige planer",
      "risk_free_recurring": "Risikofri gentagen betalingsfejl",
      "unlimited_languages": "Ubegrænsede sprog & sidevisninger",
      "high_server_resources": "Høje serverressourcer",
      "billed": {
        "day": "Faktureres dagligt",
        "week": "Faktureres ugentligt",
        "month": "Faktureres månedligt",
        "year": "Faktureres årligt"
      },
      "request_max_size": "{{0}} maks. anmodningsstørrelse"
    },
    "frequent_question": {
      "title": "Ofte stillede spørgsmål",
      "questions": {
        "trial": {
          "question": "Kan jeg bruge prøveperioden på et nyt website-domæne?",
          "answer": "Ja, vi tilbyder en 30-dages gratis prøveperiode for hvert nyt website-domæne, du tilføjer til din konto. På den måde kan du fuldt ud teste oversættelsestjenesten på din nye hjemmeside."
        },
        "seo": {
          "question": "Hvor lang tid tager det, før min SEO forbedres?",
          "answer": "Indhold og flersproget indhold tager tid at blive fuldt indekseret og godt rangeret. Afhængigt af din hjemmesides trafik og størrelse er det mellem 3 og 6 uger."
        },
        "quota": {
          "question": "Tæller menneskelige oversættelser med i kvoten?",
          "answer": "Nej, ordgrænsen gælder kun for automatiske maskinoversættelser. En oversætter kan manuelt rette automatiske oversættelser uden begrænsning."
        }
      }
    },
    "best_offer": "Bedste tilbud",
    "period": {
      "days@@one": "dag",
      "days@@other": "{{count}} dage",
      "hours@@one": "time",
      "hours@@other": "{{count}} timer",
      "minutes@@one": "minut",
      "minutes@@other": "{{count}} minutter",
      "seconds@@one": "sekund",
      "seconds@@other": "{{count}} sekunder"
    },
    "words": {
      "billion": "{{value}} mia.",
      "million": "{{value}} mio.",
      "thousand": "{{value}} tus."
    },
    "throttling_info": "{{words}} ord per {{period}}"
  },
  "profile": {
    "welcome": "Velkommen!",
    "account": "Min konto",
    "subscriptions": "Abonnementer",
    "logout": "Log ud"
  },
  "register": {
    "errors": {
      "password": "Mindst 8 tegn, alle typer"
    }
  },
  "route": {
    "dashboard": "Dashboard",
    "rules": "Regler",
    "translations": "Oversættelser",
    "search_translations": "Søgeforespørgsler",
    "urls_translations": "URL-oversættelser",
    "links": "Medier og eksterne links",
    "online_editor": "Live-editor",
    "settings": "Indstillinger",
    "domain": {
      "finish": "Indstillinger",
      "preconfig": "Indstillinger"
    },
    "home": "Hjem",
    "domain_list": "Domæneliste",
    "members": "Medlemmer",
    "invoices": "Fakturaer",
    "billing": "Betalingsoplysninger",
    "language_display": "Sprogflag-udseende",
    "payment_methods": "Betalingsmetoder",
    "ai_translation": "AI-oversættelse",
    "ai_translation_settings": "Indstillinger",
    "ai_translation_pricing": "Priser"
  },
  "rule": {
    "form": {
      "text_ignore": {
        "placeholder": "Tekst, der skal ignoreres",
        "add": "Tilføj ny",
        "title": "Tekst, der skal ignoreres",
        "description": "Tilføj én eller flere tekster, der skal ignoreres",
        "ignore_case": "Ignorer store/små bogstaver"
      },
      "html_content": {
        "title": "Anvend på HTML-indhold",
        "description": "Anvend reglen overalt i dit indhold eller ved at vælge en specifik CSS-selektor",
        "all_page": "Hele siden",
        "css_selector": "CSS-selektor",
        "label": "CSS-selektor",
        "placeholder": "Selektor, der skal anvendes på",
        "add": "Tilføj ny"
      },
      "apply_to_urls": {
        "title": "Anvend på URL'er",
        "description": "Vælg specifikke URL'er, hvor du ønsker, at reglen skal gælde",
        "all_urls": "Alle URL'er",
        "selected_urls": "Udvalgte URL'er",
        "label": "Url, der skal anvendes på",
        "placeholder": "Url, der skal anvendes på",
        "original_url": "Oprindelige URL'er",
        "translated_url": "Oversat URL",
        "wildcard": "Jokertegn",
        "regex": "Regulært udtryk",
        "add": "Tilføj ny",
        "expression": "Udtrykstype"
      },
      "apply_urls": {
        "title_exclude": "Ekskluder i URL'er",
        "title_replace": "Erstat i URL'er",
        "title_description": "Anvend også denne regel på oversættelse af URL'er"
      },
      "apply_languages": {
        "title": "Anvend på sprog",
        "description": "Vælg specifikke sprog, hvor du ønsker, at reglen skal gælde",
        "all_languages": "Alle sprog",
        "selected_languages": "Udvalgte sprog",
        "placeholder": "Vælg sprog...",
        "feedback": "Du skal vælge et sprog"
      },
      "name": {
        "title": "Titel",
        "description": "Giv din regel en titel for nemheds skyld",
        "placeholder": "Regelnavn"
      },
      "type": {
        "title": "Type",
        "description": "Vælg den type regel, du vil tilføje",
        "text_ignore": "Ignorer tekst",
        "text_replace": "Erstat tekst",
        "content_exclusion": "Ekskludering af indhold",
        "url_exclusion": "Eksklusion efter URL",
        "ignore_inline": "Ignorer inline",
        "full_description": {
          "text_ignore": "Tilføj regler for at undgå oversættelse af visse tekster. Det kan være dit produktnavn, brandnavn eller andre tekniske elementer, som du ikke ønsker oversat.",
          "text_replace": "Teksterstatning giver mulighed for at erstatte en tekst med den ønskede oversættelse, hvilket kan være nødvendigt, når oversættelsen ignorerer konteksten.",
          "content_exclusion": "Indholdseksklusion hjælper dig med at undgå oversættelse af bestemt indhold på siden.\n Hvis du helt vil ekskludere en side fra oversættelse (ingen flersproget URL overhovedet for denne side og intet oversat indhold), skal du bruge typen \"Eksklusion efter URL\"",
          "url_exclusion": "Eksklusion af sideoversættelse hjælper dig med at angive de sider, du ikke ønsker oversat.",
          "ignore_inline": "Undgå at oversætte visse inline-elementer; oversæt i stedet hver tag separat."
        }
      },
      "text_replace": {
        "title": "Tekst, der skal erstattes",
        "description": "Erstat en tekst med din specifikke oversættelse. Erstat enhver tekst på tværs af dine sider, efter sprog…",
        "text_to_replace": "Tekst, der skal erstattes",
        "ignore_case": "Ignorer store/små bogstaver",
        "text_type": "Erstatning i oversættelse",
        "text_type_original": "Oprindelig",
        "text_type_translation": "Oversættelse",
        "keep_case": "Forsøg at bevare store/små bogstaver",
        "add": "Tilføj ny"
      },
      "content_exclusion": {
        "title": "Ekskludering af indhold",
        "description": "Vælg en eller flere CSS-selektorer, som ikke skal oversættes",
        "label": "CSS-selektor",
        "placeholder": "Selektor, der skal anvendes på",
        "add": "Tilføj ny"
      },
      "multilingual_url": {
        "title": "Brug flersproget URL",
        "description": "Hvis indstillet til Ja, vil URL’en IKKE blive oversat, men siden forbliver flersproget med oversat indhold",
        "live_example_title": "Live-eksempel",
        "live_example_description": "Kilde-URL: https://yourwebsite.com/page-not-translated",
        "live_example_multilingual": "Genereret URL: https://yourwebsite.com/fr/page-not-translated",
        "live_example_no_multilingual": "Genereret URL: https://yourwebsite.com/page-not-translated"
      },
      "rule_application": {
        "description": "Anvend reglen på statisk indhold, dynamisk indhold eller begge dele",
        "title": "Anvend på indhold",
        "all": "Alt indhold",
        "static": "Statisk indhold",
        "dynamic": "Dynamisk indhold"
      },
      "force_apply_urls": {
        "title_description": "Tving anvendelse af denne regel på alle oversættelser af URL'er, inklusive eksisterende oversættelser!",
        "title_replace": "Tving erstatning i URL'er",
        "title_exclude": "Tving eksklusion i URL'er",
        "warning": "Advarsel",
        "warning_part1": "At indstille dette til \"Ja\" kan ødelægge dine URL-oversættelser.",
        "warning_part2": "Dette kan midlertidigt eller permanent generere en 404-side; fortsæt kun, hvis du forstår konsekvenserne.",
        "warning_replacement_original": "Yderligere advarsel: Du forsøger at erstatte originalt indhold, som kan påvirke URL'er; oversættelsen kan mislykkes, da Linguise ikke kan finde de oprindelige URL'er korrekt"
      }
    },
    "main": {
      "parent": "Regler",
      "edit": "Rediger regel",
      "add": "Ny regel"
    }
  },
  "rules": {
    "text_ignore": {
      "preview_single_with_url": "\"{{text_ignore}}\" ignoreres i indhold og URL",
      "preview_single": "\"{{text_ignore}}\" ignoreres i indholdet",
      "preview_more_with_url": "\"{{text_ignore}}\" og {{count}} mere ignoreres i indholdet",
      "preview_more": "\"{{text_ignore}}\" og {{count}} mere ignoreres i indholdet",
      "other_parameters": "Andre parametre er indstillet for denne regel; klik på redigeringsknappen for mere information"
    },
    "text_replace": {
      "preview_single_with_url": "\"{{original}}\" erstattes af \"{{replacement}}\" i indhold og URL'er",
      "preview_single": "\"{{original}}\" erstattes af \"{{replacement}}\" i indholdet",
      "preview_more_with_url": "\"{{original}}\" erstattes af \"{{replacement}}\" i indhold og URL'er, og {{nb}} mere",
      "preview_more": "\"{{original}}\" erstattes af \"{{replacement}}\" i indholdet, og {{nb}} mere",
      "other_parameters": "Andre parametre er indstillet for denne regel; klik på redigeringsknappen for mere information"
    },
    "content_exclusion": {
      "selectors": "{{nb}} CSS-selektor(er) ekskluderet fra oversættelse",
      "other_parameters": "Andre parametre er indstillet for denne regel; klik på redigeringsknappen for mere information"
    },
    "url_exclusion": {
      "some_multilingual": "{{nb}} URL'er ekskluderes fra oversættelse, men beholder det flersprogede præfiks",
      "some": "{{nb}} URL'er er helt ekskluderet fra oversættelse",
      "all_multilingual": "alle URL'er ekskluderes fra oversættelse, men beholder det flersprogede præfiks",
      "all": "alle URL'er er helt ekskluderet fra oversættelse",
      "other_parameters": "Andre parametre er indstillet for denne regel; klik på redigeringsknappen for mere information"
    },
    "ignore_inline": {
      "elements": "Alt inline-indhold oversættes som blokindhold på siden",
      "all_elements": "Noget inline-indhold oversættes som blokindhold på siden",
      "other_parameters": "Andre parametre er angivet for denne regel. Klik på redigeringsknappen for at få flere oplysninger."
    },
    "title": "Styring af regler",
    "description": "Administrér eksklusion og erstatning af oversættelsesindhold overalt på dit websted",
    "add": "Tilføj ny regel",
    "table": {
      "title": "Titel",
      "no_data": "Ingen regler her endnu",
      "type": "Type",
      "preview": "Forhåndsvisning af regel",
      "action": "Handling",
      "delete_confirm": "Bekræft venligst sletning af reglen",
      "types": {
        "text_ignore": "Tekst ignorer",
        "text_replace": "Tekst erstat",
        "content_exclusion": "Indhold udelukkelse",
        "url_exclusion": "URL-udelukkelse",
        "ignore_inline": "Ignorer inline",
        "unknown": "Ukendt regel"
      }
    },
    "apply_on_content": {
      "static": "Denne regel vil kun blive anvendt på statisk indhold",
      "dynamic": "Denne regel vil kun blive anvendt på dynamisk indhold"
    }
  },
  "search_translations": {
    "title": "Søgeforespørgselshåndtering",
    "description": "Liste over alle dine hjemmesideoversættelser brugt via søgeformularer (fra oversat sprog til dit domænes grundsprog)",
    "filter_languages": "Filtrér efter sprog...",
    "filter_original": "Filtrér tekst på originalsproget",
    "filter_translation": "Filtrér efter oversat tekst",
    "table": {
      "original": "Oprindelig",
      "language": "Sprog",
      "translation": "Oversættelse"
    }
  },
  "subscription": {
    "failure": {
      "tab_title": "Kunne ikke abonnere!",
      "title": "Kunne ikke abonnere!",
      "subtitle": "Der opstod en fejl under behandlingen af dit abonnement.",
      "home": "Gå tilbage til forsiden",
      "generic": "Der opstod en ukendt fejl på Linguises side; kontakt venligst administratoren!"
    },
    "success": {
      "home": "Administrér domæneoversættelser",
      "message": "Vi er dedikeret til at give dig den bedst mulige oversættelsesoplevelse. Vores ekspertteam står klar til at hjælpe dig med eventuelle spørgsmål eller support. Kom i gang ved at klikke på knappen nedenfor.",
      "subtitle": "Tak fordi du valgte Linguise oversættelsestjeneste",
      "title": "Abonnement aktiveret!",
      "tab_title": "Tak for dit abonnement!"
    }
  },
  "subscriptions": {
    "success": {
      "tab_title": "Abonnement aktiveret!",
      "title": "Abonnement aktiveret!",
      "subtitle": "Tak fordi du valgte Linguise oversættelsestjeneste",
      "message": "Vi er dedikeret til at give dig den bedst mulige oversættelsesoplevelse. Vores ekspertteam står klar til at hjælpe dig med eventuelle spørgsmål eller support. Kom i gang ved at klikke på knappen nedenfor.",
      "home": "Administrér domæneoversættelser"
    },
    "edit": {
      "title": "Administrér abonnement"
    },
    "list": {
      "title": "Abonnementer oversigt",
      "description": "Oversigt over dine domæneabonnementer"
    },
    "table": {
      "domain": "Domæne",
      "plan": "Abonnement",
      "status": "Status",
      "card": "Kort",
      "usage": "Forbrug",
      "actions": "Handlinger",
      "payment_method": "Betalingsmetode"
    },
    "usage": {
      "paid": "{{words_used}} / {{words_allowed}} ord",
      "paidOffered": "{{words_used}} / {{words_allowed}} ord\n({{free_words}} inkl. gratis ord)"
    },
    "popup": {
      "dueToday": "Samlet forfald i dag",
      "nextPeriod": "Fra {{date}}"
    }
  },
  "topbar": {
    "accounts": {
      "choose": "Vælg en konto"
    }
  },
  "translation": {
    "main": {
      "parent": "Oversættelser",
      "edit": "Redigér oversættelse"
    },
    "form": {
      "original": {
        "title": "Original på {{language}}"
      },
      "is_inline": "Denne oversættelse er foretaget på inline-indhold.",
      "inline_editor": {
        "count_warning": "Antallet af indlejrede områder stemmer ikke overens med originalen ({{current}} af {{expected}}).",
        "restore_original": "Gendan original tekst",
        "insert_placeholder": "Indsæt pladsholder",
        "drag": "Træk for at ændre rækkefølgen af området",
        "area": "Inline-område {{index}}",
        "restore": "Gendan manglende indlejrede områder"
      },
      "translation": {
        "title": "Oversættelse på {{language}}",
        "description": "Oversættelse du ønsker at overskrive"
      }
    },
    "copy": {
      "title": "Kopiér til den manuelle oversættelse",
      "label": "Kopiér til manuel"
    },
    "level": {
      "base": {
        "title": "Basisoversættelse",
        "subtitle": "Automatisk · Linguise Cloud-oversættelse",
        "empty": "Ingen basisoversættelse til denne tekst.",
        "overridden": "Dit valg er gemt, men den nyeste AI-forbedrede oversættelse vises i stedet, fordi “Overskriv manuelle og valgte oversættelser” er sat til Ja i indstillingerne for AI-oversættelse. Slå indstillingen fra for at bruge dit valg."
      },
      "not_generated": "Ikke genereret",
      "none": "Intet endnu",
      "ai": {
        "title": "AI-forbedret oversættelse",
        "subtitle": "Automatisk · Linguise AI",
        "empty_title": "Endnu ikke genereret til denne tekst",
        "empty_description": "Linguise AI giver mere naturlige oversættelser ved hjælp af konteksten på din side og dit website. Sådan får du en her:",
        "empty_step_1": "Gå til AI-oversættelse › Indstillinger, og sæt Aktiver AI-oversættelse til “Kun regler”, “Kun live-editor” eller “Regler og live-editor”.",
        "empty_step_2": "Anvend den med en regel, der matcher denne side, eller aktivér den side for side fra Live-editoren.",
        "empty_step_3": "Den AI-forbedrede oversættelse vises her, når den er genereret. Den bruger dine AI-kreditter.",
        "open_settings": "Åbn indstillinger for AI-oversættelse",
        "open_editor": "Åbn Live-editoren",
        "overrides_selection": "Dit valg er gemt, men denne AI-forbedrede oversættelse vises i stedet, fordi “Overskriv manuelle og valgte oversættelser” er sat til Ja i indstillingerne for AI-oversættelse. Slå indstillingen fra for at bruge dit valg.",
        "overrides_version": "Den version, du valgte, er gemt, men den nyeste AI-forbedrede version vises i stedet, fordi “Overskriv manuelle og valgte oversættelser” er sat til Ja i indstillingerne for AI-oversættelse. Slå indstillingen fra for at bruge den valgte version."
      },
      "manual": {
        "title": "Manuel oversættelse",
        "subtitle": "Skrevet af dig · har forrang over automatiske oversættelser",
        "empty": "Tom",
        "saved_but_overridden": "Gemt som dit valg, men vises ikke automatisk, fordi “Tilsidesæt manuelle oversættelser” er sat til Ja i indstillingerne for AI-oversættelse: Den AI-forbedrede oversættelse vinder, indtil indstillingen slås fra.",
        "ignored": "Vises ikke automatisk, fordi “Tilsidesæt manuelle oversættelser” er sat til Ja i indstillingerne for AI-oversættelse. Vælg den for at bruge den til denne tekst.",
        "label": "Din oversættelse",
        "placeholder": "Skriv din egen oversættelse...",
        "last_updated": "Sidst redigeret {{date}}",
        "save_hint": "Når du gemmer en manuel oversættelse, bliver den aktiv.",
        "delete": "Slet manuel oversættelse",
        "delete_confirm": "Bekræft venligst sletning af den manuelle oversættelse"
      }
    },
    "history": {
      "title": "AI-forbedrede versioner",
      "subtitle": "Hver regenerering fra Live-editoren gemmes",
      "unknown_model": "Ukendt model",
      "current": "Nuværende",
      "restore": "Gendan denne version",
      "restore_note": "Når du gendanner, bliver versionen den nuværende AI-forbedrede oversættelse. Intet slettes.",
      "version_of": "Version {{current}} af {{total}}",
      "hide": "Skjul historik ({{total}})",
      "show": "Vis historik ({{total}})"
    },
    "choose": {
      "title": "Oversættelser på {{language}} · vælg den, besøgende ser",
      "current": "Vises lige nu på dit website:",
      "priority": "Standardprioritet: Manuel › AI-forbedret › Basis. Dit valg gemmes kun for denne oversættelse.",
      "reset": "Nulstil til standardprioritet",
      "reset_title": "Glem dit valg for denne tekst, og brug standardprioriteten igen",
      "resetting": "Nulstiller ..."
    }
  },
  "translations": {
    "title": "Håndtering af oversættelser",
    "description": "Vis og redigér alle dine hjemmesideoversættelser – brug Live Editor til visuel oversættelse",
    "filter_languages": "Filtrér efter sprog...",
    "filter_original": "Filtrér tekst på originalsproget",
    "filter_translation": "Filtrér efter oversat tekst",
    "table": {
      "original": "Original",
      "language": "Sprog",
      "action": "Handling",
      "base": "Basis",
      "ai": "AI-forbedret",
      "manual": "Manuel"
    },
    "filter_exact": "Eksakt match",
    "badge": {
      "active": "Aktiv",
      "overrides_manual": "Tilsidesætter manuel"
    },
    "cell": {
      "none": "ingen",
      "not_generated": "ikke genereret",
      "ignored": "Ignoreret – AI-regel vinder"
    },
    "tabs": {
      "all": "Alle",
      "manual": "Med manuel",
      "ai": "Med AI-forbedret",
      "base": "Kun basis"
    },
    "levels_hint": "Hver tekst har op til 3 niveauer — det, der er markeret som Aktiv, er det, besøgende ser."
  },
  "url": {
    "main": {
      "parent": "URL'er",
      "edit": "Redigér URL-oversættelse"
    },
    "form": {
      "original": {
        "title": "Original på {{language}}"
      },
      "translation": {
        "title": "URL-oversættelse på {{language}}",
        "description": "Den URL du ønsker at overskrive",
        "placeholder": "URL-oversættelse",
        "invalid_full": "Du forsøger at erstatte i forkert format; du bør kun ændre slug/sti i URL-oversættelsen",
        "invalid": "Ugyldig URL/sti angivet"
      }
    }
  },
  "urls": {
    "title": "Håndtering af URL'er",
    "description": "Vis og redigér alle dine oversatte URL'er (avanceret – vær opmærksom på 404-fejl)",
    "filter_languages": "Filtrér efter sprog...",
    "filter_original": "Filtrér tekst på originalsproget",
    "filter_translation": "Filtrér efter oversat tekst",
    "table": {
      "original": "Original",
      "language": "Sprog",
      "url": "Oversat URL",
      "action": "Handling",
      "edited": "Den oprindelige URL er blevet redigeret"
    }
  }
}
